(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-rka-image-gallery]').forEach((gallery) => {
      if (gallery.dataset.viewerReady) return;
      const host = gallery.closest('.shopify-section') || gallery.parentElement;
      const template = host.querySelector('[data-rka-image-data]');
      const dialog = host.querySelector('[data-rka-image-viewer]');
      if (!template || !dialog || typeof dialog.showModal !== 'function') return;
      gallery.dataset.viewerReady = 'true';
      const images = Array.from(template.content.querySelectorAll('[data-src]')).map((item) => ({...item.dataset}));
      const image = dialog.querySelector('[data-rka-image-large]');
      const position = dialog.querySelector('[data-rka-image-position]');
      const previous = dialog.querySelector('[data-rka-image-previous]');
      const next = dialog.querySelector('[data-rka-image-next]');
      let index = 0;
      let trigger;
      let overflow;
      let touch;
      const show = (value) => {
        index = (value + images.length) % images.length;
        image.src = images[index].src;
        image.alt = images[index].caption;
        position.textContent = position.dataset.positionLabel.replace('[current]', index + 1).replace('[total]', images.length);
        previous.disabled = next.disabled = images.length < 2;
      };
      const open = (element, key = element.dataset.rkaImageTrigger) => {
        const selected = images.findIndex((item) => item.key === key);
        if (selected < 0) return;
        trigger = element;
        overflow = document.body.style.overflow;
        show(selected);
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      };
      gallery.querySelectorAll('[data-rka-image-trigger]').forEach((element) => {
        element.addEventListener('click', (event) => { event.preventDefault(); open(element); });
        if (element.getAttribute('role') === 'button') element.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); open(element); }
        });
      });
      const rooms = gallery.querySelector('.rka-product__room-thumbnails');
      const roomImages = images.filter((item) => item.key !== 'hero');
      if (rooms) {
        rooms.hidden = roomImages.length === 0;
        const roomPrevious = rooms.querySelector('[data-rka-room-previous]');
        const roomNext = rooms.querySelector('[data-rka-room-next]');
        const positionArrows = () => {
          const thumbnails = rooms.querySelectorAll('[data-rka-image-trigger]');
          if (!thumbnails.length) return;
          const bounds = rooms.getBoundingClientRect();
          const first = thumbnails[0].getBoundingClientRect();
          const last = thumbnails[thumbnails.length - 1].getBoundingClientRect();
          roomPrevious.style.left = Math.max(-20, first.left - bounds.left - 52) + 'px';
          roomNext.style.right = Math.max(-20, bounds.right - last.right - 52) + 'px';
        };
        positionArrows();
        new ResizeObserver(positionArrows).observe(rooms);
        rooms.querySelectorAll('img').forEach((item) => item.addEventListener('load', positionArrows));
        roomPrevious.addEventListener('click', () => open(roomPrevious, roomImages.at(-1).key));
        roomNext.addEventListener('click', () => open(roomNext, roomImages[0].key));
      }
      dialog.querySelector('[data-rka-image-close]').addEventListener('click', () => dialog.close());
      previous.addEventListener('click', () => show(index - 1));
      next.addEventListener('click', () => show(index + 1));
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); show(index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      });
      dialog.addEventListener('close', () => { document.body.style.overflow = overflow; trigger?.focus({preventScroll:true}); });
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      const stage = dialog.querySelector('[data-rka-image-stage]');
      stage.addEventListener('touchstart', (event) => {
        touch = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null;
      }, {passive:true});
      stage.addEventListener('touchend', (event) => {
        if (!touch || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - touch.x;
        const dy = event.changedTouches[0].clientY - touch.y;
        touch = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1));
      }, {passive:true});
      stage.addEventListener('touchcancel', () => {touch = null;}, {passive:true});
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', () => initialize());
})();

